export default "__VITE_ASSET__K03or3yu__"